/**
 * @fileoverview Module for `src/dashboard/DashboardStats.js`.
 */

import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

/**
 * Displays the user's high-level dashboard stats for adopted and mailed voters.
 *
 * @param {Object} params
 * @returns {JSX.Element} Dashboard stats sidebar content.
 */
function DashboardStats({ adoptedVoters, alreadySent, toSend, uniqueStates }) {
  return (
    <div className='col-xl-5 col-12 p-5 p-sm-5 p-xl-0 dashboard-stats-panel'>
      <h3 className='mb-2'>My letter writing stats</h3>
      <div className='row stats-row'>
        <div className='col-xs-12 col-lg-4 mb-3'>
          <h6>
            <span>Voters adopted</span>
          </h6>
          <div>{ adoptedVoters }</div>
        </div>
        <div className='col-xs-12 col-lg-4 mb-3'>
          <h6>
            <span>Letters prepared</span>
          </h6>
          <div>{ toSend + alreadySent }</div>
        </div>
        <div className='col-xs-12 col-lg-4 mb-3'>
          <h6>
            <span>Letters sent</span>
          </h6>
          <div>{ alreadySent }</div>
        </div>
      </div>
      <div className='row stats-row'>
        <div className='col-xs-12 mb-3'>
          <h6>Places you&rsquo;re writing to</h6>
          <div>{ uniqueStates.join(', ') }</div>
        </div>
      </div>
      <div className='row stats-info'>
        <div className='col-xs-12 mb-3'>
          Want to see stats from campaigns you&rsquo;ve worked on in the past?
          { ' ' }
          <br className='d-none d-lg-block' />
          <strong>Check out your <Link to='/history'>Vote Forward history</Link></strong>.
        </div>
      </div>
    </div>
  );
}

DashboardStats.propTypes = {
  adoptedVoters: PropTypes.number.isRequired,
  alreadySent: PropTypes.number.isRequired,
  toSend: PropTypes.number.isRequired,
  uniqueStates: PropTypes.array.isRequired,
};

export default DashboardStats;
